import { BankAccountType } from "@/apis/gql/types";
import {
  CreditCard,
  Home,
  Landmark,
  Lock,
  PiggyBank,
  Users,
  Wallet,
} from "lucide-react";

export default function getAccountTypeIcon(type: BankAccountType) {
  switch (type) {
    case BankAccountType.CHECKING:
      return Wallet;
    case BankAccountType.SAVINGS:
      return PiggyBank;
    case BankAccountType.CREDIT_CARD:
      return CreditCard;
    case BankAccountType.SECURITY:
      return Lock;
    case BankAccountType.LOAN:
      return Landmark;
    case BankAccountType.MEMBERSHIP:
      return Users;
    case BankAccountType.BAUSPAREN:
      return Home;
    default:
      return CreditCard;
  }
}
